import { useEffect, useRef } from 'react'

const useBodyScrollDisable = (isShowScrollAfterDestroy = true) => {
  const scrollPositionRef = useRef(0)

  const disableScroll = () => {
    scrollPositionRef.current = window.pageYOffset
    document.body.style.overflow = 'hidden'
  }

  const enableScroll = () => {
    document.body.style.overflow = ''
    window.scrollTo(0, scrollPositionRef.current)
  }

  useEffect(() => {
    disableScroll()

    return () => {
      if (isShowScrollAfterDestroy) {
        enableScroll()
      }
    }
  }, [isShowScrollAfterDestroy])

  const bodyScrollDisable = () => {
    disableScroll()
  }

  return { bodyScrollDisable, enableScroll }
}

export default useBodyScrollDisable
